import {FuseLoadable} from '@fuse';

export const M3InfrastructureConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/millenniumiaas/M3Infrastructure',
            component: FuseLoadable({
                loader: () => import('./M3Infrastructure')
            })
        },
      
       
      

    ]
};

